<template>
  <div class="app-container">
    <el-container>
      <div class="tabs_custom">
        <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
          <el-tab-pane label="所有患者" name="first">
            <patientList v-if="activeName == 'first'"></patientList>
          </el-tab-pane>
          <el-tab-pane label="待管理患者" name="second">
            <patientContactList v-if="activeName == 'second'"></patientContactList>
          </el-tab-pane>
          <el-tab-pane label="我管理的" name="third">
            <patientMyList v-if="activeName == 'third'"></patientMyList>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-container>
  </div>
</template>

<script>
import patientList from './patientList.vue';
import patientContactList from './patientContactList.vue';
import patientMyList from './patientMyList.vue'

export default {
  components: { patientList, patientContactList, patientMyList },
  props: {

  },
  data() {
    return {
      activeName: "first",
    };
  },
  created() {
  },
  methods: {
    // 点击切换tab标签页事件
    handleClick(target, action) {
      console.log(target.name, action)
      this.activeName = target.name;
    }
  }
};
</script>

<style lang="scss" scoped>
.app-container{
  overflow: auto !important;
}
.tabs_custom {
  // overflow: auto !important;

  ::v-deep {
    .el-tabs__content {
      overflow: auto !important;
    }
  }
}
</style>